import { useQuery } from '@apollo/client';
import { LAUNCH_DARKLY_FLAGS } from '../graphql/queries';
import { LDUser } from '../commons/ld-user';
import { APPLICATION_NAME } from '../commons/constants';

const useFlags = ({ ldFlagsCountry, language, currency, bookingCountry }) => {
  const { loading: ldLoadingD, data: ldDataD } = useQuery(LAUNCH_DARKLY_FLAGS, {
    variables: {
      ldUser: LDUser(),
      officeID: ldFlagsCountry?.office?.code || 'MIA',
      country: ldFlagsCountry?.code || 'USA',
      application: APPLICATION_NAME,
      clientApp: APPLICATION_NAME,
      language: language || 'en',
      brand: 'ROYAL',
      currency: currency || 'USD',
      bookingCountry: bookingCountry || 'USA',
    },
    fetchPolicy: 'cache-first',
  });

  const ldFlags = ldDataD?.ldFlags;

  return { ldLoadingD, ldFlags };
};

export default useFlags;
